import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sortByOrder'
})
export class SortByOrderPipe<T> implements PipeTransform {

  transform(value: T[], key?: string): T[] {
    return value?.sort(
      (a, b) =>
        a[key] - b[key]
    );
  }

}
